import { PpFiles } from './pp-files';
import { PpPlayer } from './pp-player';

export const PP = () => {
  return (
    <>
      <PpFiles />
      <PpPlayer />
    </>
  );
};
